"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequisiteCertificate = void 0;

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var RequisiteCertificate =
/** @class */
function () {
  function RequisiteCertificate(rawCertificate) {
    var _this = this;

    this.rawCertificate = rawCertificate; // приводим тип, т.к. enum'ы отличаются регистром :(

    this.type = function () {
      return _this.rawCertificate.type.toLowerCase();
    };

    this.thumbprint = function () {
      return _this.rawCertificate.thumbprint.toLowerCase();
    };

    this.inn = function () {
      return _this.rawCertificate.subjectInn;
    };

    this.kpp = function () {
      return _this.rawCertificate.subjectKpp;
    };

    this.issuer = function () {
      return _this.rawCertificate.issuerCommonName;
    };

    this.owner = function () {
      return _this.rawCertificate.subjectFio;
    };

    this.subjectType = function () {
      return _this.subjectTypeValue;
    };

    this.organizationName = function () {
      return _this.rawCertificate.subjectOrganization;
    };

    this.validTo = function () {
      return new Date(_this.rawCertificate.validTo);
    };

    this.validFrom = function () {
      return new Date(_this.rawCertificate.validFrom);
    };

    this.serialNumber = function () {
      return _this.rawCertificate.serialNumber.toLowerCase();
    };

    this.hasPrivateKey = function () {
      return false;
    };

    this.isQualified = function () {
      return _this.rawCertificate.isQualified;
    };

    this.isCloud = function () {
      return _this.rawCertificate.type.toLowerCase() === Plugin_1.CertificateType.Cloud;
    };

    this.cryptoProvider = function () {
      return undefined;
    };

    this.containerInfo = function () {
      return undefined;
    };

    this.publicKeyLength = function () {
      return undefined;
    };

    this.publicKeyAlgorithm = function () {
      return _this.rawCertificate.publicKeyAlgorithm;
    };

    this.licenseBuiltin = function () {
      return _this.rawCertificate.isLicenseBuildIn;
    };

    this.ogrn = function () {
      return _this.rawCertificate.subjectOgrn;
    };

    this.toBase64 = function () {
      return _this.rawCertificate.rawData || '';
    };

    this.raw = function () {
      return _this.rawCertificate;
    };

    this.extensions = function () {
      return {};
    };

    this.title = function () {
      return '';
    };
    /**
     * Enum сервера и фрона не совпадают, поэтому нужен этот матчинг
     */


    this.processRawSubjectType = function (rawType) {
      switch (rawType) {
        case 'IndividualEntrepreneur':
          return Plugin_1.CertificateSubjectType.IP;

        case 'LegalEntity':
          return Plugin_1.CertificateSubjectType.UL;

        case 'Person':
        case 'Unknown':
        default:
          return Plugin_1.CertificateSubjectType.FL;
      }
    };

    this.subjectTypeValue = this.processRawSubjectType(this.rawCertificate.legalStatus);
  }

  return RequisiteCertificate;
}();

exports.RequisiteCertificate = RequisiteCertificate;